@use "variables" as *;

.title {
  font-size: $fontSize-l;
  margin-left: $spacing-s;
  margin-right: $spacing-m;
}

.appBar {
  height: $appBarHeight;
}

.toolbar {
  padding-left: $spacing-s;
  padding-right: $spacing-s;
}

.piperLogo {
  margin-right: $spacing-s;
}

.mainBody {
  display: flex;
  min-height: calc(100% - #{$appBarHeight});
  padding: 0 !important;
}

.detailBody {
  width: 100%;
  padding: $spacing-m $spacing-m $spacing-l $spacing-m;
}

.mainContainer {
  width: 100%;
  height: 100%;
  display: flex;
}

.buttonsDiv {
  padding-top: $spacing-m;
  padding-bottom: $spacing-m;
  padding-right: $spacing-s;
  margin-left: $spacing-s;
  overflow: auto !important;
}

.buttonsDivMobile {
  padding-top: $spacing-m;
  padding-bottom: $spacing-m;
  overflow: auto !important;
}

.list {
  flex-grow: 1;
  padding-top: $spacing-m !important;
}

.resizeHandle {
  width: $spacing-m;
  display: flex;
  justify-content: center;
}

.button {
  width: 100%;
}
